module.exports = __webpack_public_path__ + "static/media/food-truck-catering.cbbee7ad.jpg";